import { render, staticRenderFns } from "./TaskViewDescriptionPopup.vue?vue&type=template&id=64f82461&scoped=true&lang=pug&"
import script from "./TaskViewDescriptionPopup.vue?vue&type=script&lang=js&"
export * from "./TaskViewDescriptionPopup.vue?vue&type=script&lang=js&"
import style0 from "./TaskViewDescriptionPopup.vue?vue&type=style&index=0&id=64f82461&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f82461",
  null
  
)

export default component.exports